// styles
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    color,
    data,
    fmtYearAbbrev,
    fmtYearFull,
    fmtMonth,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
  } = props;

  const xTicks = isMobile ? 5 : 10;
  // const xTicks = isMobile ? 5 : 10;
  const yTicks = isMobile ? 7 : 7;

  // const ticksMobi = ['1/1/1930', '1/1/1940', '1/1/1950', '1/1/1960', '1/1/1970', '1/1/1980', '1/1/1990', '1/1/2000', '1/1/2010', '1/1/2020'];
  // const ticksMobi = ['2018', '2019', '2020', '2021', '2022'];
  const ticksMobi = ['Dec.', 'Jan. ’22', 'Feb.', 'March', 'April'];

  const dates = {
    January: 'Jan.',
    // February: 'Feb.',
    // March: 'March',
    April: 'April',
    // May: 'May',
    // June: 'June',
    July: 'July',
    // August: 'Aug.',
    // September: 'Sept.',
    October: 'Oct.',
    // November: 'Nov.',
    // December: 'Dec.',
  };
  //
  // const xGrid = xAxis(x)
  //  .ticks(xTicks);


  // legend
  container.insert('ul', ':first-child')
    .attr('class', 'key')
    .selectAll('li')
    .data(data)
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block' style='background-color:${color(d.id)};'></span> ${d.id}`);

  // svg
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x)
      .tickValues(ticksMobi));

 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y).ticks(yTicks));

  // add tick prefix or suffix here
  // `${d}M`
  // `$${d}`
  yGrid.selectAll('text')
    .text(d => `$${d}`);

  yGrid.selectAll('line').attr('x2', width);

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'line');

  lines.append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));

  // labels
  const label = lines.append('g')
    .attr('class', 'data-label');

  label.append('text')
    .style('text-anchor', 'start')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 5;
      const y0 = y(d0.value) + 3;
      return `translate(${[x0, y0]})`;
    })
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;
      return `$${(value).toFixed(2).replace('.00', '')}`; // per bushel
    });

  label.append('text')
    .style('text-anchor', 'start')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 5;
      const y0 = y(d0.value) - (isMobile ? 10 : 13);
      return `translate(${[x0, y0]})`;
    })
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;
      return 'April 5';
    });

  label
    .append('rect')
    .attr('x', x(x.domain()[0]) - 5)
    .attr('y', y(y.domain()[1]) - 3)
    .style('fill', 'white')
    .attr('width', isMobile ? 60 : 70)
    .attr('height', 10);
  label
    .append('text')
    .attr('x', x(x.domain()[0]) - 5)
    .attr('y', y(y.domain()[1]) + 5)
    .text('per tonne');
}
